<script>
    import ICONS from '../../lib/data/icons';

    export let name;
    export let color   = 'black';
    export let size    = 24;
    export let rotate  = 0;
    export let cssFill = '';

	const icon = ICONS[name] || {};
</script>

<svg
	width={size}
	height={size}
	viewBox={icon.viewbox}
	style="--rotate:{rotate}deg; --color: {cssFill ? `var(${cssFill})` : color}"
	class:primary={color === 'primary'}
>
	<path d={icon.path} />
</svg>

<style type="text/scss" lang="scss">
	svg {
		transform: rotate(var(--rotate));
		fill: var(--color);
	}
</style>
